import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQuery } from "react-responsive";
import classNames from "classnames";
import "./Hero.scss";
export const BannerContainer = ({ bottomMobileImg, fullscreen, headerContent, isLogged, loggedTitle, unloggedTitle, loggedContent, unloggedContent, }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const mobileBottomBackgroundStyle = isMobile && !!bottomMobileImg ? { backgroundImage: `url(${bottomMobileImg})` } : {};
    const bannerContainerClass = classNames("hero__container", {
        "hero__container--logged": isLogged,
        "hero__container--not-fullscreen": !fullscreen,
    });
    return (_jsxs("div", { className: bannerContainerClass, "data-testid": "hero__background-container", style: mobileBottomBackgroundStyle, children: [_jsx("div", { className: "hero__header", children: headerContent }), _jsx("div", { className: "hero__title", children: isLogged ? loggedTitle : unloggedTitle }), _jsx("div", { className: "hero__content", children: isLogged ? loggedContent : unloggedContent })] }));
};
//# sourceMappingURL=BannerContainer.js.map